import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {PageRequest} from '../core/pagination/page-request';
import {SignaalkaartAntwoord, SignaalkaartAntwoordDto, VraagAntwoord} from './signaalkaart-antwoord';
import {Observable} from 'rxjs';
import {Page, PageDto} from '../core/pagination/page';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SignaalkaartAntwoordService {
  private http = inject(HttpClient);

  getSignaalkaartAntwoordenPage$(clientId: string, pageRequest: PageRequest<SignaalkaartAntwoord>): Observable<Page<SignaalkaartAntwoord>> {
    return this.http
      .post<PageDto<SignaalkaartAntwoordDto>>(`${environment.apiUrl}/signaalkaartantwoorden/page`, {
        ...pageRequest,
        clientId
      })
      .pipe(map(pageDto => new Page(
        pageDto.ascending,
        pageDto.pageSize,
        pageDto.pageNumber,
        pageDto.lastPage,
        pageDto.items.map(dto => SignaalkaartAntwoord.deserialize(dto))
      )));
  }

  postSignaalkaartAntwoord$(
    signaalkaartId: string,
    signaalkaartVersie: number,
    clientId: string,
    antwoorden: Array<VraagAntwoord>,
    dienstId: string): Observable<SignaalkaartAntwoord> {
    return this.http
      .post<SignaalkaartAntwoordDto>(`${environment.apiUrl}/signaalkaartantwoorden`,
        {signaalkaartId, signaalkaartVersie, clientId, antwoorden, dienstId})
      .pipe(map(dto => SignaalkaartAntwoord.deserialize(dto)));
  }

  getSignaalkaartById(id: string): Observable<SignaalkaartAntwoord> {
    return this.http.get<SignaalkaartAntwoordDto>(`${environment.apiUrl}/signaalkaartantwoorden/${id}`)
      .pipe(map(dto => SignaalkaartAntwoord.deserialize(dto)));
  }
}
